
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { TestTube } from "lucide-react";
import { CoordinateDebugger } from "./CoordinateDebugger";

export const CoordinateTestButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="text-purple-600 border-purple-300 hover:bg-purple-50">
          <TestTube size={16} className="mr-2" />
          Debug Coordinates
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Coordinate System Debugger</DialogTitle>
        </DialogHeader>
        <CoordinateDebugger />
      </DialogContent>
    </Dialog>
  );
};
